import React, { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import HomePage from "../pages/home";
import NewHomePage from "../pages/new-home";
import Scan from "@/pages/scan";
import Webview from "@/pages/webview";
const SharePage = lazy(() => import("@/pages/share")); // 我的二维码
const BilibiliAuthPage = lazy(() => import("@/pages/bilibili-auth"));
const KuaishouAuthPage = lazy(() => import("@/pages/kuaishou-auth"));

export const routes: RouteObject[] = [
  { path: "/web/douyin", element: <HomePage /> },
  { path: "/web/douyin-auth", element: <NewHomePage /> },
  {
    path: "/web/douyin/share",
    element: (
      <Suspense>
        <SharePage />
      </Suspense>
    ),
  },
  {
    path: "/web/scan",
    element: (
      <Suspense>
        <Scan />
      </Suspense>
    ),
  },
  {
    path: "/web/scan/:code",
    element: (
      <Suspense>
        <Scan />
      </Suspense>
    ),
  },
  {
    path: "/web/webview",
    element: (
      <Suspense>
        <Webview />
      </Suspense>
    ),
  },
  {
    path: "/web/bilibili-auth",
    element: (
      <Suspense>
        <BilibiliAuthPage />
      </Suspense>
    ),
  },
  {
    path: "/web/kuaishou-auth",
    element: (
      <Suspense>
        <KuaishouAuthPage />
      </Suspense>
    ),
  },
];
